import { useQuery } from '@tanstack/react-query'
import { RegulatoryThreshold } from '../types'

const API_BASE_URL = process.env.REACT_APP_API_URL || 'http://localhost:3000'

export function useRegulatoryThresholds(
  category?: 'regulatory' | 'other'
) {
  return useQuery<RegulatoryThreshold[]>({
    queryKey: ['regulatory-thresholds', category],
    queryFn: async () => {
      const params = new URLSearchParams()
      if (category) {
        params.append('category', category)
      }
      
      const response = await fetch(
        `${API_BASE_URL}/api/v1/regulatory_thresholds?${params.toString()}`
      )
      if (!response.ok) {
        throw new Error('Failed to fetch regulatory thresholds')
      }
      return response.json()
    },
    staleTime: 1000 * 60 * 60, // 1 hour - thresholds don't change often,
  })
}

export function useRegulatoryThreshold(analyte: string, guideline: string = 'FDA') {
  return useQuery<RegulatoryThreshold>({
    queryKey: ['regulatory-threshold', analyte, guideline],
    queryFn: async () => {
      const response = await fetch(
        `${API_BASE_URL}/api/v1/regulatory_thresholds/${encodeURIComponent(analyte)}?guideline=${guideline}`
      )
      if (!response.ok) {
        throw new Error(`Failed to fetch threshold for ${analyte}`)
      }
      return response.json()
    },
    staleTime: 1000 * 60 * 60, // 1 hour
    enabled: !!analyte, // Only run if analyte is provided
  })
}
